import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const CircleXIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="circle-x-icon"
      viewBox="0 0 58 58"
    >
      <path
        fill={fill || '#7E8A96'}
        d="M40.42 21.954a2.632 2.632 0 00-3.59-3.85l-7.7 7.177-7.177-7.7a2.631 2.631 0 10-3.85 3.588l7.177 7.7-7.7 7.177a2.631 2.631 0 103.588 3.85l7.7-7.177 7.177 7.7a2.632 2.632 0 003.85-3.588l-7.176-7.7 7.7-7.177z"
      />
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M.052 29C.052 13.013 13.012.053 29 .053 44.987.053 57.947 13.013 57.947 29c0 15.987-12.96 28.947-28.947 28.947C13.012 57.947.052 44.987.052 29zM29 52.684C15.92 52.684 5.315 42.081 5.315 29 5.315 15.92 15.92 5.316 29 5.316 42.08 5.316 52.684 15.92 52.684 29c0 13.08-10.604 23.684-23.684 23.684z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CircleXIcon;
